 // ==== Sidebar Posts Slider ====
document.addEventListener('DOMContentLoaded', function () {
    var postsSlider = $('.sidebar-posts-slider');
    if (postsSlider.length) {
        var postsSwiper = new Swiper(postsSlider.get(0), {
            slidesPerView: 1,
            speed: 1000,
            loop: true,
            spaceBetween: 20,
            pagination: {
                el: postsSlider.find('.swiper-pagination').get(0),
                clickable: true,
            },
        });
    }
  });
    // ==== End Sidebar Posts Slider ====

     // ==== Age Popup ====
    const ageConfirmed = localStorage.getItem('age_verified');

    if (!ageConfirmed) {
        Fancybox.show(
            [
                {
                    src: '#age-verify',
                    type: 'inline',
                },
            ],
            {
                // 1. DISABLE BACKGROUND CLICK
                Click: {
                    outside: null, // This stops closing when clicking the backdrop
                    backdrop: null, // Extra layer of protection for the background area
                },

                // 2. DISABLE KEYBOARD (ESC KEY)
                keyboard: {
                    Escape: null, // Specifically disables the Escape key
                },

                // 3. DISABLE TOUCH/SWIPE GESTURES (MOBILE)
                dragToClose: false, // Prevents swiping the modal away

                // 4. REMOVE THE "X" CLOSE BUTTON
                showClass: 'f-fadeIn',
                hideClass: 'f-fadeOut',
                closeButton: false, // Hide the default close button

                // 5. LOCK SCROLLING
                l10n: {
                    CLOSE: 'Verify Age First', // Changes accessibility text
                },
            }
        );
    }

    $('#age-confirm').on('click', function () {
        localStorage.setItem('age_verified', 'true');
        Fancybox.close();
    });

    $('#age-deny').on('click', function () {
        window.location.href = 'https://www.google.com';
    });
    // ==== End Age Popup ====

    
function resetSwatches() {
  $('#cl_optionsapp .customily_option.tw-swatch .swatch-container label,\
     #cl_optionsapp .customily_option.tw-swatch .swatch-container label img,\
     #cl_optionsapp .customily_option.tw-swatch .swatch-container .csh-image-container')
    .removeAttr('style');
}

function resetSwatchesMultipleTimes() {
  resetSwatches();
  let count = 0;
  const interval = setInterval(function () {
    resetSwatches();
    count++;
    if (count >= 20) {
      clearInterval(interval);
    }

  }, 200);
}

/* =========================
   CUSTOMILY INITIAL LOAD
========================= */

window.addEventListener('customily-options-loaded', function () {
  resetSwatchesMultipleTimes();
});

/* =========================
   CATEGORY CLICK
========================= */

$(document).on(
  'click',
  '#cl_optionsapp .customily_option.tw-category',
  function () {
    resetSwatchesMultipleTimes();
  }
);

/* =========================
   PREVENT TASTING KIT SCROLL JUMP
========================= */

let poursTrulyAnchorTop = null;
let poursTrulySpacer = null;
let poursTrulySpacerMinHeight = '';
let restoreNativeScrollToTimer = null;

function temporarilyDisableVariantSmoothScroll() {
  if (window.__poursTrulyNativeScrollTo) {
    clearTimeout(restoreNativeScrollToTimer);
  } else {
    window.__poursTrulyNativeScrollTo = window.scrollTo;
    window.scrollTo = function () {
      const options = arguments[0];
      if (options && typeof options === 'object' && options.behavior === 'smooth') return;
      return window.__poursTrulyNativeScrollTo.apply(window, arguments);
    };
  }

  restoreNativeScrollToTimer = setTimeout(function () {
    if (!window.__poursTrulyNativeScrollTo) return;
    window.scrollTo = window.__poursTrulyNativeScrollTo;
    delete window.__poursTrulyNativeScrollTo;
  }, 2500);
}

function getVariantLabel(input) {
  if (!input) return null;

  const currentInput = document.getElementById(input.id) || Array.from(
    document.querySelectorAll('variant-selects input[type="radio"]')
  ).find(function (variantInput) {
    return variantInput.value.trim() === input.value.trim();
  });

  if (!currentInput || !currentInput.id) return null;
  return document.querySelector(`label[for="${CSS.escape(currentInput.id)}"]`);
}

function updatePoursTrulyNotice(selectedValue) {
  const showNotice = selectedValue.trim() === 'Pours Truly Tasting Kit';
  document.querySelectorAll('[data-pours-truly-notice]').forEach(function (notice) {
    notice.hidden = !showNotice;

    if (showNotice) {
      const quantityForm = document.querySelector('[id^="Quantity-Form-"]');
      if (quantityForm && quantityForm.parentElement) {
        quantityForm.parentElement.insertBefore(notice, quantityForm);
      }
    }
  });
}

function positionInitialPoursTrulyNotice() {
  const selectedWine = document.querySelector(
    'variant-selects input[type="radio"]:checked, variant-selects select'
  );
  if (selectedWine) updatePoursTrulyNotice(selectedWine.value);
}

document.addEventListener('DOMContentLoaded', positionInitialPoursTrulyNotice);
window.addEventListener('customily-options-loaded', positionInitialPoursTrulyNotice);

$(document).on(
  'click',
  '#cl_optionsapp .customily_option input[type="radio"], variant-selects input[type="radio"]',
  function () {
    if (this.value.trim() === 'Pours Truly Tasting Kit') {
      temporarilyDisableVariantSmoothScroll();

      const label = getVariantLabel(this);
      poursTrulyAnchorTop = label ? label.getBoundingClientRect().top : null;

      const customilyOptions = document.querySelector('#cl_optionsapp');
      if (customilyOptions && customilyOptions.parentElement) {
        poursTrulySpacer = customilyOptions.parentElement;
        poursTrulySpacerMinHeight = poursTrulySpacer.style.minHeight;
        poursTrulySpacer.style.minHeight = `${customilyOptions.getBoundingClientRect().height}px`;
      }
    }
  }
);

$(document).on(
  'change',
  '#cl_optionsapp .customily_option input[type="radio"], variant-selects input[type="radio"]',
  function () {
    updatePoursTrulyNotice(this.value);

    if (
      this.value.trim() !== 'Pours Truly Tasting Kit' ||
      poursTrulyAnchorTop === null
    ) return;

    const selectedInput = this;
    const restoreVariantPosition = function () {
      const customilyOptions = document.querySelector('#cl_optionsapp');
      if (customilyOptions && customilyOptions.getBoundingClientRect().height > 1) return;

      const label = getVariantLabel(selectedInput);
      if (!label) return;

      if (poursTrulySpacer) {
        poursTrulySpacer.style.minHeight = poursTrulySpacerMinHeight;
      }

      const positionDifference = label.getBoundingClientRect().top - poursTrulyAnchorTop;
      if (Math.abs(positionDifference) > 1) {
        window.scrollBy({ top: positionDifference, behavior: 'instant' });
      }

      poursTrulySpacer = null;
    };

    // Customily hides its fields asynchronously. React to the actual collapse
    // instead of relying only on a timer, whose timing varies by device/network.
    const customilyOptions = document.querySelector('#cl_optionsapp');
    if (customilyOptions) {
      const collapseObserver = new MutationObserver(function () {
        requestAnimationFrame(restoreVariantPosition);
      });

      collapseObserver.observe(customilyOptions, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      setTimeout(function () {
        restoreVariantPosition();
        collapseObserver.disconnect();
      }, 2500);
    }

    setTimeout(restoreVariantPosition, 900);
    setTimeout(restoreVariantPosition, 1500);
  }
);

/* =========================
   DAWN VARIANT CHANGE
========================= */

$(document).on(
  'change',
  '.product-form input[type="radio"], variant-selects input, variant-selects select',
  function () {
    resetSwatchesMultipleTimes();
  }
);

/* =========================
   CUSTOM VARIANT EVENT
========================= */
document.addEventListener('variant:change', function () {
  resetSwatchesMultipleTimes();
});


// footer link for label code

document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  // Sirf ?label=custom par chalega
  if (params.get("label") !== "custom") return;

  let attempts = 0;

  const interval = setInterval(function () {
    attempts++;

    // Step 1: Upload/Create your own label
    const customCategory = Array.from(
      document.querySelectorAll('.customily_option.tw-category input[type="radio"]')
    ).find(input => input.value.trim() === "Upload/Create your own label");

    if (customCategory && !customCategory.checked) {
      customCategory.click();
      return;
    }

    // Step 2: Upload Your Own Label
    const uploadOwn = Array.from(
      document.querySelectorAll('.customily_option input[type="radio"]')
    ).find(input => input.value.trim() === "Upload Your Own Label");

    if (uploadOwn) {
      if (!uploadOwn.checked) {
        uploadOwn.click();
      }

      clearInterval(interval);
      console.log("Customily: Upload Your Own Label selected");
    }

    if (attempts >= 40) {
      clearInterval(interval);
    }
  }, 500);
});

// sticky product image box
document.addEventListener("DOMContentLoaded", function () {
 if (!window.productTags) return;
 if (window.productTags.includes("sticky-side-mini-preview-box")) {
  // Mobile only
  if (!window.matchMedia("(max-width: 767px)").matches) return;

  const mediaWrapper = document.querySelector(".product__media-wrapper");
  if (!mediaWrapper) return;

  const formButtons = document.querySelector(".product-form__buttons");
  if (!formButtons) return;

  // Wait for canvas
  function initMiniPreview() {

    const previewCanvas =
      document.getElementById("cloned-canvas") ||
      document.getElementById("preview-canvas");

    if (!previewCanvas) {
      setTimeout(initMiniPreview, 300);
      return;
    }

    // Prevent duplicate creation
    if (document.querySelector(".mini-preview")) return;

    /* MINI PREVIEW */
    const miniPreview = document.createElement("div");
    miniPreview.className = "mini-preview";
    miniPreview.innerHTML = `
  <div class="mini-preview-loader">
    <div class="spinner"></div>
  </div>

  <img class="mini-preview-img" src="" alt="Preview" />

  <span class="mini-preview-text">Click To Expand</span>
`;
    document.body.appendChild(miniPreview);

    const miniPreviewImg = miniPreview.querySelector(".mini-preview-img");
    const loader = miniPreview.querySelector(".mini-preview-loader");
    let previewLoaded = false;

    /* OVERLAY */
    const overlay = document.createElement("div");
    overlay.className = "preview-overlay";
    document.body.appendChild(overlay);

    /* CLOSE BUTTON */
    const closeBtn = document.createElement("div");
    closeBtn.className = "preview-close";
    closeBtn.innerHTML = "✕";
    mediaWrapper.appendChild(closeBtn);

    /* LIVE UPDATE */
   
function updateMiniPreview() {

  try {

    const dataUrl = previewCanvas.toDataURL("image/png");

    // Blank canvas ko ignore karo
    if (dataUrl.length > 5000) {

      miniPreviewImg.src = dataUrl;

      if (!previewLoaded) {
        previewLoaded = true;

        miniPreviewImg.onload = function () {
         
        };
      }
    }

  } catch (e) {}

  requestAnimationFrame(updateMiniPreview);
}

    updateMiniPreview();
function toggleMiniLoader() {

    const customilyLoader = document.querySelector(".loadingoverlay");

    const visible = customilyLoader &&
        getComputedStyle(customilyLoader).display !== "none" &&
        getComputedStyle(customilyLoader).visibility !== "hidden" &&
        parseFloat(getComputedStyle(customilyLoader).opacity) > 0;

    loader.style.display = visible ? "flex" : "none";
    miniPreviewImg.style.visibility = visible ? "hidden" : "visible";
}

const observer = new MutationObserver(toggleMiniLoader);

observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["style", "class"]
});

toggleMiniLoader();
    /* SCROLL */

    window.addEventListener("scroll", function () {

      const mediaRect = mediaWrapper.getBoundingClientRect();
      const formRect = formButtons.getBoundingClientRect();

      const imageAreaEnded = mediaRect.bottom < 0;
      const beforeFormButtons = formRect.top > 0;

      if (imageAreaEnded && beforeFormButtons) {
        miniPreview.classList.add("show");
      } else {
        miniPreview.classList.remove("show");
      }

    });

    /* OPEN */

    miniPreview.addEventListener("click", function () {
      mediaWrapper.classList.add("preview-expanded");
      overlay.classList.add("show");
      document.body.classList.add("no-scroll");
    });

    function closePreview() {
      mediaWrapper.classList.remove("preview-expanded");
      overlay.classList.remove("show");
      document.body.classList.remove("no-scroll");
    }

    closeBtn.addEventListener("click", closePreview);
    overlay.addEventListener("click", closePreview);

  }

  initMiniPreview();
 }
});


document.addEventListener("DOMContentLoaded", function() {
    if (!window.productTags) return;
    if (window.productTags.includes("hide-preview-image-box")) {
    const previewBtn = document.querySelector(".hide-show-preview-btn");
    const header = document.querySelector(".section-header");
    const productSticky = document.querySelector(".product__media-wrapper");
    const previewImageContainer = document.querySelector(".product__column-sticky");
    const hideShowBtn = document.querySelector("[data-hide-show-preview-btn]") || null;

    // Scroll handler
    window.addEventListener("scroll", function () {
      const scrolled = window.pageYOffset > 0;

      // Sticky product section toggle
      document.body.classList.toggle("sticky-true", scrolled);
      productSticky?.classList.toggle("main-sticky-div", scrolled);
      previewBtn?.classList.toggle("prod-button-hide", scrolled);

      // Header sticky logic for mobile view
      if (previewBtn && header && window.innerWidth <= 768) {
        const btnRect = previewBtn.getBoundingClientRect();
        const isVisible = btnRect.top >= 0 && btnRect.bottom <= window.innerHeight;
        header.classList.toggle("make-sticky", !isVisible);
      }
    });

    // Toggle preview image button
    if(hideShowBtn){
      hideShowBtn.addEventListener("click", function(e) {
        e.preventDefault();
        this.classList.toggle("preview-hidden");
        previewImageContainer?.classList.toggle("sticky-button-hidden");
        const btnText = this.querySelector(".btn-text");
        if(btnText) {
          btnText.innerHTML = this.classList.contains("preview-hidden") ? "SHOW PREVIEW IMAGE" : "HIDE PREVIEW IMAGE";
        }
        document.body.classList.toggle("hide-it");
      });
    }
     }
  });

  
// event date pick code here

document.addEventListener("DOMContentLoaded", function () {

  flatpickr("#event-date", {
    minDate: "today",
    dateFormat: "F j, Y",
    disableMobile: true,
    allowInput: false,

    onReady: function (selectedDates, dateStr, instance) {

      if (instance.calendarContainer.querySelector(".calendar-top")) return;

      const top = document.createElement("div");

      top.className = "calendar-top";

      top.innerHTML = `
        <div class="calendar-title">
          THIS CALENDAR IS ONLY FOR SELECTING EVENT DATES
        </div>
      `;

      instance.calendarContainer.prepend(top);

      const clear = document.createElement("div");

      clear.className = "calendar-clear";

      clear.innerHTML = "CLEAR DATE";

      clear.onclick = function () {
        instance.clear();
        instance.close();
      };

      instance.calendarContainer.appendChild(clear);

    }

  });

});

// Pours kit image position chnage code here
function changePoursTrulyImage() {
  if (!window.location.pathname.includes("pours-truly")) return;

  const gallery = document.querySelector(".product__media-list");
  const thumbs = document.querySelector(".thumbnail-list");

  if (!gallery || !thumbs) {
    requestAnimationFrame(changePoursTrulyImage);
    return;
  }

  const slides = gallery.querySelectorAll(".product__media-item");
  const thumbItems = thumbs.querySelectorAll(".thumbnail-list__item");

  if (slides.length >= 2) {
    gallery.prepend(slides[1]);
    slides[0].remove(); // hide ki jagah remove
  }

  if (thumbItems.length >= 2) {
    thumbs.prepend(thumbItems[1]);
    thumbItems[0].remove();
  }
}

document.addEventListener("DOMContentLoaded", changePoursTrulyImage);
